module.exports = __webpack_public_path__ + "static/img/buzzer-1.7ee8ca8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/buzzer-1.svg
// module id = ySnk
// module chunks = 0